export default function SectionTitle({ title }) {
  return <h2 className="section-title">{title}</h2>;
}
